<template>
	<div class="switch flex">
		<div 
			v-for="option in options"
			class="option flex h-center v-center" 
			:class="{current : option.value == modelValue}"
			@click="select(option.value)"
			:title="option.title"
		>
			<span class="small-font" >{{ option.text }}</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Switch',
		props: ['modelValue', 'options'],
		emits: ['update:modelValue', 'change'],
		methods: {
			select(value){
				this.$emit('update:modelValue', value);
				this.$emit('change', value);
			}
		}
	}
</script>

<style scoped lang="scss">
	.switch{
		background: #EDEDED;
		border-radius: 24px;
		height: 24px;
		
		.option{
			border-radius: 24px;
			padding: 8px;
			text-align: center;
			width: 100%;
			cursor: pointer;
			white-space: nowrap;
			gap: 10px;
			
			&:hover{
				background: #D4D4D4;
			}
			
			&.current{
				background: black;
				color: white;
				cursor: default;
			}
			
		}
		
		&.small-padding .option{
			padding: 8px 12px;
		}
	}
</style>
